<div
  class="ds-radii-8"
  [class.ds-p-base]="addBackground"
  [ngClass]="{
    'ds-bg-success-100': addBackground && type === 'success' && !disabled,
    'ds-bg-error-100': addBackground && type === 'danger' && !disabled,
    'ds-bg-warning-100': addBackground && type === 'warning' && !disabled,
    'ds-bg-primaryshade-100': addBackground && type === 'info' && !disabled,
    'ds-bg-gray-100': addBackground && (type === 'default' || disabled)
  }"
>
  <mat-icon
    [svgIcon]="icon"
    [style.width]="width"
    [style.height]="height"
    [class]="type"
    class="d-flex"
    [class.disabled]="disabled"
  ></mat-icon>
</div>
